import React from 'react';
import { SHeader } from './styled/SHeader';

interface HeaderProps {
    bordered?: boolean;
}

const Header: React.FC<HeaderProps> = ({children, bordered = true}) => (
    <SHeader className={'box-header'} bordered={bordered}>{children}</SHeader>
);

export default Header;
